import React, { useState, useEffect, useRef, useContext } from "react";
import { useTranslation } from "react-i18next";
import DatePicker from "react-datepicker";
import { dateToDateFormat } from "util";

import auditTrailContext from "util/context/auditTrail";

import ModalPortal from "util/component/Modal";
import { Modal } from "util/component/Modal/Modal";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarDays, faFilter, faUser } from "@fortawesome/free-solid-svg-icons";

import axios from "util/axios";

import AsyncSelect from "react-select/async";

const FUNCTIONS = [
    { value: "index1", label: "Index 1" },
    { value: "index2", label: "Index 2" },
    { value: "index3", label: "Index 3" },
    { value: "index4", label: "Index 4" },
    { value: "index5", label: "Index 5" },
    { value: "index6", label: "Index 6" },
    { value: "index7", label: "Index 7" },
];

const customStyle = {
    option: (provided, state) => ({
        ...provided,
        paddingLeft: "4px",
        textAlign: "center",
        width: "100%",
        color: state.isDisabled ? "#CCC" : "#000",
        backgroundColor: state.isFocused ? "#EEEEFF" : "#FFF",
    }),
    singleValue: (provided, state) => ({
        ...provided,
        color: "#555",
        textAlign: "center",
    }),
    menu: (provided, state) => ({
        ...provided,
        width: "max-content",
        minWidth: "100%",
        zIndex: 20,
        backgroundColor: "#FFF",
    }),
    control: (provided, state) => ({
        ...provided,
        borderColor: "#AAA",
        backgroundColor: "transparent",
        boxShadow: "none",
        minHeight: "initial",
    }),
    valueContainer: (provided, state) => ({
        ...provided,
        padding: "0",
    }),
    placeholder: (provided, state) => ({
        ...provided,
        textAlign: "center",
        paddingRight: "5px",
        color: state.isDisabled ? "transparent" : "#CCC",
    }),
    dropdownIndicator: (provided, state) => ({
        ...provided,
        padding: "4px",
    }),
    indicatorSeparator: (provided, state) => ({
        ...provided,
        marginBottom: 0,
        marginTop: 0,
    }),
};

const SelectBox = ({ api, value, onChange }) => {
    const filterOption = (data, inputValue) => {
        return data?.filter(
            (i) =>
                i.label?.toLowerCase().includes(inputValue.toLowerCase()) ||
                i.value?.toLowerCase().includes(inputValue.toLowerCase())
        );
    };

    const promiseOptions = (inputValue) =>
        new Promise((resolve) => {
            axios.post(process.env.REACT_APP_API + api).then((Response) => {
                const result = Response.data.data.result;
                resolve(filterOption(result, inputValue));
            });
        });

    return (
        <AsyncSelect
            cacheOptions
            loadOptions={promiseOptions}
            defaultOptions
            className={"searchable-dropdown"}
            styles={customStyle}
            value={value}
            isMulti
            onChange={onChange}
        />
    );
};

const SearchBox = () => {
    const { t } = useTranslation(["page"]);
    // const [functionFilter, setFunctionFilter] = useState(null);
    // const [userFilter, setUserFilter] = useState(null);
    const { apiCall } = useContext(auditTrailContext);
    const [dateRange, setDateRange] = useState([new Date().setMonth(new Date().getMonth() - 1), new Date().getTime()]);
    const [search, setSearch] = useState({ method: null, user: null, auth: null });

    const [startDate, endDate] = dateRange;
    const [openDate, setOpenDate] = useState(false);
    const [alert, setAlert] = useState(false);

    const apiCallHandler = () => {
        const [prev, next] = dateRange;
        if (prev && next) {
            const diffTime = new Date(next).getTime() - new Date(prev).getTime();
            if (Math.abs(diffTime / (1000 * 60 * 60 * 24)) > 365) {
                setAlert(true);
            } else {
                apiCall({prev, next, ...search});
            }
        } else {
            setAlert(true);
        }
    };

    useEffect(() => {
        apiCallHandler();
    }, []);

    const onChangeValidate = (data) => {
        const [prev, next] = data;
        if (prev && next) {
            setOpenDate(false);
        }
        setDateRange(data);
    };

    const userChanged = (data) => {
        setSearch((OLD) => ({ ...OLD, user: data }));
    };

    const methodChange = (data) => {
        setSearch((OLD) => ({ ...OLD, method: data }));
    };

    const authChange = (data) => {
        setSearch((OLD) => ({ ...OLD, auth: data }));
    };

    return (
        <>
            <div className={`search-box`}>
                <div className={`search-box-item`}>
                    <label htmlFor={"dateSelector"} className={`icon-label`}>
                        <FontAwesomeIcon icon={faCalendarDays} />
                    </label>
                    <div className={`input-group`}>
                        <input
                            type="text"
                            id={"dateSelector"}
                            readOnly
                            className={`date-selector`}
                            onFocus={(e) => {
                                e.target.blur();
                                setOpenDate(!openDate);
                            }}
                            value={`${dateToDateFormat(startDate, true)} ${
                                endDate ? `~ ${dateToDateFormat(endDate, true)}` : ""
                            }`}
                        />
                        {openDate && (
                            <div style={{ position: "absolute", width: "max-content", zIndex: "20" }}>
                                <DatePicker
                                    selectsRange
                                    inline
                                    dateFormat="yyyy/MM/dd"
                                    monthsShown={2}
                                    startDate={startDate}
                                    endDate={endDate}
                                    onChange={onChangeValidate}
                                />
                            </div>
                        )}
                    </div>

                    <label htmlFor={"methodSelector"} className={`icon-label`}>
                        <FontAwesomeIcon icon={faFilter} />
                    </label>
                    <div className={`input-group v2`}>
                        <div style={{ width: "100%" }}>
                            <SelectBox api={`/history/retrieveMethod`} onChange={methodChange} value={search.method} />
                        </div>
                    </div>
                </div>
                <div className={`search-box-item`}>
                    <label htmlFor={"userSelector"} className={`icon-label`}>
                        <FontAwesomeIcon icon={faUser} />
                    </label>
                    <div className={`input-group  v2`}>
                        <div style={{ width: "100%" }}>
                            <SelectBox api={"/user/retrieveUserListForSearch"} onChange={userChanged} value={search.user} />
                        </div>
                    </div>
                    <div className={`input-group`}>
                        <div className={`radio-group`}>
                            <label htmlFor={`userTypeAll`}>All</label>
                            <input
                                type="radio"
                                id={`userTypeAll`}
                                name={`userType`}
                                checked={!search.auth}
                                onChange={() => {
                                    authChange(null);
                                }}
                            />
                            <label htmlFor={`userTypeAdmin`}>Admin</label>
                            <input
                                type="radio"
                                id={`userTypeAdmin`}
                                name={`userType`}
                                checked={search.auth === "Y"}
                                onChange={() => {
                                    authChange("Y");
                                }}
                            />
                            <label htmlFor={`userTypeUser`}>User</label>
                            <input
                                type="radio"
                                id={`userTypeUser`}
                                checked={search.auth === "N"}
                                name={`userType`}
                                onChange={() => {
                                    authChange("N");
                                }}
                            />
                        </div>
                    </div>
                </div>
                <div className={`btn-box`}>
                    <button className={`bpl-btn`} onClick={apiCallHandler}>
                        Search
                    </button>
                </div>
            </div>
            {alert && (
                <ModalPortal>
                    <Modal onClose={() => setAlert(false)}>{t("selectYear1")}</Modal>;
                </ModalPortal>
            )}
        </>
    );
};

export default SearchBox;
